var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"map-container relative"},[_c('svg',{ref:"map",staticClass:"rounded-lg",attrs:{"width":_vm.width,"height":_vm.height}}),(_vm.error)?_c('div',{staticClass:"ot-placeholder absolute inset-0"},[_vm._v(" Map not available ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }